import {
  Component,
  Output,
  EventEmitter,
  Inject,
  ViewChild,
  OnInit,
  Renderer2,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { RootReducerState } from 'src/app/store';
import { Store } from '@ngrx/store';
import { changeMode } from 'src/app/store/layouts/layout-action';
import { getLayoutmode } from 'src/app/store/layouts/layout-selector';
import { Router } from '@angular/router';

import { NotificationDto } from '../../../app/core/models/payment-notification';

import { BaseService } from 'src/app/core/services/base.service';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from 'src/app/core/services/language.service';
import { TokenAuthService } from '../../core/services/tokenauth.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ProfileRefreshService } from 'src/app/core/services/profile-refresh.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit, OnDestroy {
  notifications: NotificationDto[] = [];
  unreadCount: number = 0;

  private subscriptions = new Subscription();

  countryName: string = 'Arabic';
  flagvalue: string = 'assets/images/flags/ae.svg';
  cookieValue: string = 'ar';

  element: any;
  mode: string | undefined;

  currentuser = {} as any;

  @Output() mobileMenuButtonClicked = new EventEmitter();
  @ViewChild('removeNotificationModal', { static: false })
  removeNotificationModal?: ModalDirective;
  @ViewChild('removeCartModal', { static: false })
  removeCartModal?: ModalDirective;

  deleteid: any;
  totalNotify: number = 0;
  newNotify: number = 0;
  readNotify: number = 0;

  listLang = [
    { text: 'Arabic', flag: 'assets/images/flags/ae.svg', lang: 'ar' },
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
  ];

  constructor(
    @Inject(DOCUMENT) private document: any,
    public languageService: LanguageService,
    public _cookiesService: CookieService,
    public store: Store<RootReducerState>,
    private tokenAuthService: TokenAuthService,
    private router: Router,
    private renderer: Renderer2,
    public baseService: BaseService,
    private notificationService: NotificationService,
    private profileRefreshService: ProfileRefreshService,
  ) {}

  async ngOnInit(): Promise<void> {
    const currentUser = this.tokenAuthService.currentUserValue();
    this.currentuser = currentUser;

    this.element = document.documentElement;

    const lang = this._cookiesService.get('lang') || 'ar';

    this.languageService.setLanguage(lang);
    this.setCurrentLanguageData(lang);
    this.updateDirection(lang);

    this.listenToPaymentNotifications();

    this.profileRefreshService.refreshTopbar$.subscribe(() => {
      const updatedUser = this.tokenAuthService.currentUserValue();

      this.currentuser = updatedUser;
    });
  }

  private listenToPaymentNotifications(): void {
    this.subscriptions.add(
      this.notificationService.notificationsList$.subscribe(
        (notifications: NotificationDto[]) => {
          this.notifications = notifications;

          this.unreadCount = this.notifications.filter((x) => !x.isRead).length;
          this.totalNotify = this.notifications.length;
          this.newNotify = this.unreadCount;
          this.readNotify = this.notifications.filter((x) => x.isRead).length;
        },
      ),
    );
  }

  clearNotifications(): void {
    this.notificationService.clearNotifications();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  toggleLanguage() {
    const currentLang = this.languageService.getCurrentLanguage();
    const newLang = currentLang === 'ar' ? 'en' : 'ar';

    this.baseService.showAppLoader();

    setTimeout(() => {
      this.languageService.setLanguage(newLang);
      this.updateDirection(newLang);
      window.location.reload();
    }, 300);
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;

    this.baseService.showAppLoader();

    setTimeout(() => {
      this.languageService.setLanguage(lang);
      this.updateDirection(lang);
      window.location.reload();
    }, 300);
  }

  private loadRtlStyle(lang: string): void {
    const existingLink = document.getElementById('app-rtl-style');

    if (existingLink) {
      existingLink.remove();
    }

    if (lang === 'ar') {
      const link = document.createElement('link');
      link.id = 'app-rtl-style';
      link.rel = 'stylesheet';
      link.href = 'app-rtl.css';

      document.head.appendChild(link);
    }
  }

  private setCurrentLanguageData(lang: string) {
    const selectedLang =
      this.listLang.find((x) => x.lang === lang) || this.listLang[0];

    this.countryName = selectedLang.text;
    this.flagvalue = selectedLang.flag;
    this.cookieValue = selectedLang.lang;
  }

  private updateDirection(lang: string): void {
    const body = document.body;
    const html = document.documentElement;

    if (lang === 'ar') {
      this.renderer.removeClass(body, 'ltr');
      this.renderer.addClass(body, 'rtl');

      this.renderer.setAttribute(body, 'dir', 'rtl');
      this.renderer.setAttribute(html, 'dir', 'rtl');
      this.renderer.setAttribute(html, 'lang', 'ar');
    } else {
      this.renderer.removeClass(body, 'rtl');
      this.renderer.addClass(body, 'ltr');

      this.renderer.setAttribute(body, 'dir', 'ltr');
      this.renderer.setAttribute(html, 'dir', 'ltr');
      this.renderer.setAttribute(html, 'lang', 'en');
    }

    this.loadRtlStyle(lang);

    localStorage.setItem('lang', lang);
  }

  windowScroll() {}

  changeMode(mode: string) {
    this.mode = mode;

    if (mode === 'auto') {
      document.documentElement.setAttribute('data-bs-theme', 'light');
      document.documentElement.setAttribute('data-topbar', 'light');
      document.documentElement.classList.add('mode-auto');
    } else {
      this.store.dispatch(changeMode({ mode }));

      this.store.select(getLayoutmode).subscribe((mode) => {
        document.documentElement.setAttribute('data-bs-theme', mode);
      });

      document.documentElement.classList.remove('mode-auto');
      document.documentElement.setAttribute('data-topbar', mode);
    }
  }

  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open');
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');

    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        this.document.msExitFullscreen();
      }
    }
  }

  handleImgError(event: any) {
    const img = event.target as HTMLImageElement;

    if (!img.src.includes('placeholder.jpg')) {
      img.src = 'assets/images/users/UserAvatarPlaceholder.jpg';
    }
  }

  logout() {
    this.tokenAuthService.logout();
    localStorage.removeItem('accessToken');
    this.router.navigate(['/auth/login']);
  }
}
